import React from 'react';
import { ucFirst } from '../../../services/UtilsService';
import { PageTitle } from '../../../shared/styles/styles';
import { PAGE_NAME } from './StockTransfer.constants';

const StockTransferHeader = () => <PageTitle className={'median'}>{ucFirst(PAGE_NAME)}</PageTitle>;
export default StockTransferHeader;
